import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const PROXY = process.env.REACT_APP_API_URL + "api/campaign";
const GENERAL_PROXY = process.env.REACT_APP_API_URL + "api/general";

export const fetchCampaigns = createAsyncThunk('campaign/fetch-campaigns', async ({ page = 1, limit = 10, search = "", oem = "" } = {}) => {
    const res = await axios.get(`${PROXY}/fetch-campaigns`, {
        params: { page, limit, search, oem }
    });
    return res.data.result;
});

export const saveCampaign = createAsyncThunk('campaign/create-campaign', async (campaignData) => {
    const res = await axios.post(`${PROXY}/create-campaign`, campaignData);
    return res.data;
});

export const deleteCampaign = createAsyncThunk('campaign/delete-campaign', async (campaignId) => {
    const res = await axios.delete(`${PROXY}/delete-campaign`, { data: { id: campaignId } });
    return res.data;
});

export const updateCampaign = createAsyncThunk('campaign/update-campaign', async ({ campaignId, campaignData }) => {
    const res = await axios.put(`${PROXY}/update-campaign`, { id: campaignId, ...campaignData });
    return res.data;
});

export const fetchSubSources = createAsyncThunk('campaign/fetch-sub-sources', async () => {
    const res = await axios.get(`${GENERAL_PROXY}/get-subsources`);
    return res.data.result;
});

const campaignSlice = createSlice({
    name: 'campaign',
    initialState: {
        campaigns: [],
        totalDocs: 0,
        totalPages: 1,
        page: 1,
        limit: 10,
        hasPrevPage: false,
        hasNextPage: false,
        subSources: [],
        status: {
            fetch: 'idle',
            save: 'idle',
            delete: 'idle',
            update: 'idle',
            fetchSubSources: 'idle'
        },
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch Campaigns
            .addCase(fetchCampaigns.pending, (state) => {
                state.status.fetch = 'loading';
            })
            .addCase(fetchCampaigns.fulfilled, (state, action) => {
                state.status.fetch = 'succeeded';
                const result = action.payload || {};
                state.campaigns = result.docs || [];
                state.totalDocs = result.totalDocs || 0;
                state.totalPages = result.totalPages || 1;
                state.page = result.page || 1;
                state.limit = result.limit || 10;
                state.hasPrevPage = result.hasPrevPage || false;
                state.hasNextPage = result.hasNextPage || false;
            })
            .addCase(fetchCampaigns.rejected, (state, action) => {
                state.status.fetch = 'failed';
                state.error = action.error.message;
            })

            // Save Campaign
            .addCase(saveCampaign.pending, (state) => {
                state.status.save = 'loading';
            })
            .addCase(saveCampaign.fulfilled, (state) => {
                state.status.save = 'succeeded';
            })
            .addCase(saveCampaign.rejected, (state, action) => {
                state.status.save = 'failed';
                state.error = action.error.message;
            })

            // Delete Campaign
            .addCase(deleteCampaign.pending, (state) => {
                state.status.delete = 'loading';
            })
            .addCase(deleteCampaign.fulfilled, (state) => {
                state.status.delete = 'succeeded';
            })
            .addCase(deleteCampaign.rejected, (state, action) => {
                state.status.delete = 'failed';
                state.error = action.error.message;
            })

            // Update Campaign
            .addCase(updateCampaign.pending, (state) => {
                state.status.update = 'loading';
            })
            .addCase(updateCampaign.fulfilled, (state) => {
                state.status.update = 'succeeded';
            })
            .addCase(updateCampaign.rejected, (state, action) => {
                state.status.update = 'failed';
                state.error = action.error.message;
            })

            // Fetch Sub Sources
            .addCase(fetchSubSources.pending, (state) => {
                state.status.fetchSubSources = 'loading';
            })
            .addCase(fetchSubSources.fulfilled, (state, action) => {
                state.status.fetchSubSources = 'succeeded';
                state.subSources = action.payload || [];
            })
            .addCase(fetchSubSources.rejected, (state, action) => {
                state.status.fetchSubSources = 'failed';
                state.error = action.error.message;
            })
    }
});

export default campaignSlice.reducer;